<script>
import Notification from '@/Components/Utilities/Notification'

export default {
    components: {
        Notification
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['updateNotificationsCount', 'closeNotificationTray'],
    data: () => ({
        idleDuration: 30, //seconds until not fetching notifications
        getNotificationsInterval: 60, //seconds between fetching notifications
        getDrawerInterval: 60, //seconds between updating drawer
        notificationOnScreen: 10, //seconds for notifications to stay on screen
        notifications: null,
        toasts: null
    }),
    mounted() {
        this.getNotificationsForTray()
        this.getToastNotifications()
        this.intervalFunction(this.getNotificationsForTray, this.getDrawerInterval * 1000)
        this.intervalFunction(this.getToastNotifications, this.getNotificationsInterval * 1000)

    },
    methods: {
        intervalFunction(fn, interval) {
            setInterval(function () {
                if (document.hasFocus()) {
                    fn()
                }
            }, interval)
        },
        async getNotificationsForTray() {
            const { data: { data } } = await axios.get(route('ajax.notifications.index', 'unread'))

            if (data) {
                data.forEach(function (part, index, notificationsArray) {
                    notificationsArray[index].notification = JSON.parse(part.notification)
                })

                this.notifications = data
                this.$emit('updateNotificationsCount', this.notifications.length)
            }
        },
        async getToastNotifications() {
            const { data: { data } } = await axios.get(route('ajax.notifications.index', 'undelivered'))

            if (data) {
                data.forEach(function (part, index, notificationsArray) {
                    notificationsArray[index].notification = JSON.parse(part.notification)
                })

                this.toasts = data
                this.toasts.forEach((toast) => {
                    setTimeout(() => {
                        toast.visible = true
                    }, 1000)
                    setTimeout(() => {
                        if (toast.notification.onscreen !== '-1') {
                            toast.visible = false
                            this.toasts.splice(this.toasts.findIndex(item => item.uid === toast.uid), 1)
                            this.getNotificationsForTray()
                        }
                    }, toast.notification.onscreen ? parseInt(toast.notification.onscreen) * 1000 : 10000)
                })
            }
        },
        async markAsRead(uid) {
            await axios.post(route('ajax.notification.update', uid))
            this.notifications.splice(this.notifications.findIndex(item => item.uid === uid), 1)
            this.$emit('updateNotificationsCount', this.notifications.length)
        },
        markToastAsRead(uid) {
            this.toasts.splice(this.toasts.findIndex(item => item.uid === uid), 1)
            this.markAsRead(uid)
        },
        closeNotificationTray() {
            this.$emit('closeNotificationTray')
        }
    }
}
</script>

<template>
    <transition
        appear
        name="slide"
    >
        <article
            v-show="show"
            class="absolute top-0 right-0 z-20 w-96 h-full bg-white shadow-left"
        >
            <div
                id="notification_close"
                class="flex absolute top-10 -left-9 justify-center items-center w-9 h-9 text-center text-white bg-rss-blue-500 rounded-l-lg cursor-pointer"
                @click="closeNotificationTray"
            >
                <i class="fas fa-times" />
            </div>
            <div class="overflow-y-auto p-4 max-h-screen help-text">
                <ul
                    v-if="notifications !== null"
                    id="notifications-intray"
                    class="overflow-hidden notifications"
                >
                    <transition-group
                        name="slide"
                        tag="ul"
                    >
                        <li
                            v-for="notification in notifications"
                            :id="'notification-' + notification.id"
                            :key="notification.id"
                            :class="'notification animated notification-theme-' + notification.notification.theme"
                            :data-uid="notification.uid"
                        >
                            <notification
                                :notification="notification"
                                @mark-read="markAsRead"
                            />
                        </li>
                    </transition-group>
                </ul>
                <p v-else>
                    {{ __("No notifications") }}
                </p>
            </div>
        </article>
    </transition>
    <transition
        appear
        name="toast"
    >
        <ul
            v-if="toasts && toasts.length > 0"
            class="overflow-y-auto fixed top-0 right-0 z-20 p-4 w-96 max-h-screen"
        >
            <li
                v-for="notification in toasts"
                :key="notification.id"
                :data-uid="notification.uid"
            >
                <notification
                    :notification="notification"
                    @mark-read="markToastAsRead"
                />
            </li>
        </ul>
    </transition>
</template>

<style scoped>
.slide-enter-active, .slide-leave-active {
    transition: .6s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-enter {
    transform: translate(-100%, 0);
}

.slide-enter-from,
.slide-leave-to {
    transform: translate(100%, 0);
}

.toast-enter-active, .toast-leave-active {
    transform: translate(0, 0);
    transition: transform .6s cubic-bezier(0.68, -0.6, 0.32, 1.6);
}

.toast-enter-from, .toast-leave-to {
    transform: translate(100%, 0);
}
</style>
